<template>
  <v-layout wrap align-start>
    <v-flex xs10 md6>
      <!-- <label for="seller">Has seller:</label> -->
      <v-combobox
        chips
        clearable
        multiple
        solo
        v-model="chips"
        :items="dataOfSellers"
        label="Sellers"
        id="seller"
        item-text="seller"
        item-value="id"
        background-color="rgba(48, 127, 255, 0.1)"
        @change="$emit('selectedSellers', $event)"
      >
        <template v-slot:selection="data">
          <v-chip
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            @click:close="remove('seller', data.item.id)"
          >
            <strong>{{ data.item.seller }}</strong>
          </v-chip>
        </template>
      </v-combobox>
      <v-checkbox
        class="ma-0"
        color="primary"
        :disabled="!sellerIds.length > 0"
        hide-details
        v-model="sellerInvert"
        @change="$store.commit('productModule/SET_sellerInvert', sellerInvert)"
      />
    </v-flex>
    <v-flex xs10 md6>
      <!-- <label for="domains">Has domain:</label> -->
      <v-combobox
        v-model="domains"
        :items="dataOfDomains"
        label="Domains"
        background-color="rgba(48, 127, 255, 0.1)"
        domains
        clearable
        solo
        multiple
        id="domains"
        item-text="domain"
        item-value="id"
        @change="$emit('selectedDomains', $event)"
      >
        <template v-slot:selection="data">
          <v-chip
            :input-value="data.selected"
            close
            @click:close="remove('domain', data.item.id)"
          >
            <strong>{{ data.item.domain }}</strong>
          </v-chip>
        </template>
      </v-combobox>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'SellersDomainFilter',
  props: {
    sellerIds: {
      type: Array,
      default: null
    }
  },
  data: () => ({
    chips: [],
    domains: [],
    dataOfSellers: [],
    dataOfDomains: [],
    sellerInvert: false
  }),
  created () {
    this.loadSellers()
    this.loadDomains()
  },
  methods: {
    remove (type, id) {
      if (type === 'seller') {
        this.chips = this.chips.filter((chip) => chip.id !== id)
        this.$emit('selectedSellers', this.chips)
        return
      }

      this.domains = this.domains.filter((domain) => domain.id !== id)
      this.$emit('selectedDomains', this.domains)
    },
    loadSellers () {
      this.$store.dispatch('productModule/loadSellers').then(res => {
        this.dataOfSellers = res
      })
    },
    loadDomains () {
      this.$store.dispatch('productModule/loadDomains').then(res => {
        this.dataOfDomains = res
      })
    }
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/product/SellersDomainsFilter.vue